<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{text.Heading}}</h2>
      <div class="mod-has-label">
        <h3 class="title-lv3" v-if="model.OrderList.length===0">{{text.NoItem}}</h3>
        <div class="mod-normal-box confirm" v-for="(order, index) in model.OrderList" :key="index">
          <h3 class="title-lv3">{{text.Column.OrderDate}}：{{order.order_datetime}}</h3>
          {{text.Column.OrderNumber}}：{{order.order_number}}<br>
          {{text.Column.ReservedNumber}}：{{order.pos_transaction_no}}<br>
          {{text.Column.PaymentNumber}}：{{order.docomo.payment_number}}<br>
          {{text.Column.TotalAmount}}：{{order.total_price}}{{text.Elements.Yen}}<br>
          {{text.Column.ShopName}}：{{order.receiving_method.store_name}}<br>
          {{text.Column.ShopAddress}}：{{order.receiving_method.store_address}}<br>
          <input :id="'acd-check' + index" class="acd-check" type="checkbox">
          <label class="acd-label" :for="'acd-check' + index">{{text.ShowDetail}}</label>
          <div class="acd-content">
            <div class="mod-has-label">
              <div class="mod-normal-box">
                <div class="order-detail-wrap">

                  <div class="order-detail-item" v-for="(od, odi) in order.order_details" :key="odi">
                    <h3 class="item-coupon-use" v-if="checkUseCoupon(od.coupon_cd)">{{text.Elements.UseCoupon}}</h3>
                    <h3 class="item-name"><span v-html="order.display_item_info[odi].item_name"></span></h3>
                    <div class="quantity">{{text.Elements.Quantity}}{{od.quantity}}</div>
                    <p class="order-price"><strong>¥{{displayThousandsSeparator(od.price)}}</strong><small>{{getTaxDisplay(order.tax_type)}}</small></p>
                  </div>

                  <div class="order-detail-item" v-if="order.accounting_coupon!==null">
                    <h3 class="item-coupon-use">{{text.Elements.UseCoupon}}</h3>
                    <h3 class="item-coupon-detail"><span v-html="order.accounting_coupon.name"></span></h3>
                    <p class="order-price"><strong>¥{{displayThousandsSeparator(order.accounting_coupon.discount_price)}}</strong><small>{{getTaxDisplay(order.tax_type)}}</small></p>
                  </div>

                  <p class="total-price"><small>{{text.Elements.Total}}</small><strong>¥{{displayThousandsSeparator(order.total_price)}}</strong><small>{{getTaxDisplay(order.tax_type)}}</small></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="mod-form-btn btn-back"><a href="#" class="btn-base btn-negative btn-quit" @click.prevent="goTop">{{text.GoTop}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DirectStoreAccessMixin from '@/mixins/DirectStoreAccessMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import {get, isEmpty} from 'lodash'
export default {
  name: 'FKMODconnectAuth',
  mixins: [ CommonMixin, DirectStoreAccessMixin, DisplayErrorMixin ],
  data () {
    return {
      text: {
        Heading: null,
        NoItem: null,
        Column: {
          OrderDate: null,
          OrderNumber: null,
          ReservedNumber: null,
          PaymentNumber: null,
          TotalAmount: null,
          ShopName: null,
          ShopAddress: null
        },
        Elements: {
          UseCoupon: null,
          Quantity: null,
          Total: null,
          Yen: null
        },
        ShowDetail: null,
        GoTop: null
      },
      model: {
        OrderList: []
      }
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({ name: 'Index' })
    },
    checkUseCoupon: function (couponCode) {
      return !isEmpty(couponCode)
    },
    getOrderHistory: async function () {
      const self = this
      const params = {}
      params.type = 9
      params.limit = 5
      params.language = sessionStorage.getItem('lang')

      try {
        const res = await this.callApi('OrderHistory', params)
        if (get(res, 'data.result', true)) {
          this.model.OrderList = get(res, 'data.value.order_list', [])
        } else {
          this.errorFromApi(res.data.errorCode, res.data.error)
        }
      } catch (error) {
        this.errorFromAxios(error)
      } finally {
        self.setDisabledButton(false)
      }
    },
    initView: function () {
      this.text.Heading = this.$i18n.t('OrderHistory.Head')
      this.text.NoItem = this.$i18n.t('OrderHistory.NoItem')
      this.text.Column.OrderDate = this.$i18n.t('OrderHistory.OrderDate')
      this.text.Column.OrderNumber = this.$i18n.t('Order.OrderNumber')
      this.text.Column.ReservedNumber = this.$i18n.t('Order.ReservedNumber')
      this.text.Column.PaymentNumber = this.$i18n.t('Order.PaymentNumber')
      this.text.Column.TotalAmount = this.$i18n.t('OrderHistory.OrderAmount')
      this.text.Column.ShopName = this.$i18n.t('OrderHistory.ShopName')
      this.text.Column.ShopAddress = this.$i18n.t('OrderHistory.ShopAddress')
      this.text.Elements.UseCoupon = this.$i18n.t('Cart.UseCoupon')
      this.text.Elements.Quantity = this.$i18n.t('General.Quantity')
      this.text.Elements.Total = this.$i18n.t('General.Total')
      this.text.Elements.Yen = this.$i18n.t('General.Yen')
      this.text.ShowDetail = this.$i18n.t('OrderHistory.ShowDetail')
      this.text.GoTop = this.$i18n.t('OrderHistory.GoTop')
    }
  },
  // onload
  beforeMount () {
    this.model.DPayEnabled = this.$store.getters.isDPayEnabled
    // 注文履歴取得
    this.getOrderHistory()
  },
  mounted () {
    this.initView()
  }
}
</script>

<style>
.acd-check{
display: none;
}
.acd-label{
display: block;
text-align: center;
padding-top: 15px;
}
.acd-content{
height: 0;
opacity: 0;
padding: 0 10px;
transition: .5s;
visibility: hidden;
}
.acd-check:checked + .acd-label + .acd-content{
height: auto;
opacity: 1;
visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderHistory.vue